<template>
  <div class="main-container">
    <div class="title-back">
      <p class="title">详情</p>
      <Button type="primary" ghost class="backBtn" @click="goBack()">返回</Button>
    </div>
    <div class="status-salesman">
      <div class="status">
        <img v-if="policyDetail.payState == 1" src="@/assets/images/icon/org/fee-stay.png" />
        <img v-else-if="policyDetail.payState == 2" src="@/assets/images/icon/org/fee-success.png" />
        <img v-else-if="policyDetail.payState == 3" src="@/assets/images/icon/org/fee-fail.png" />

        <span class="text stay" v-if="policyDetail.payState == 1">即将到期——{{ policyDetail.endDesc }}</span>
        <span class="text success" v-else-if="policyDetail.payState == 2">续保成功</span>
        <span class="text fail" v-else-if="policyDetail.payState == 3">未续保——{{ policyDetail.remark }}</span>
      </div>
      <div class="salesman">
        业务员：
        <span class="user-info">{{ policyDetail.orgName }}</span>
        -
        <span class="user-info">{{ policyDetail.salesmanName }}</span>
      </div>
    </div>

    <form-item :formData="policyDetail"></form-item>

    <Tabs v-model="tabIndex" :animated="false">
      <!-- 即将到期不显示变更记录 -->
      <TabPane label="变更记录" name="1" v-show="policyDetail.payState == 2 || policyDetail.payState == 3"></TabPane>
      <TabPane label="原单投保信息" name="2"></TabPane>
      <div slot="extra">
        <!-- 即将到期 -->
        <template v-if="policyDetail.payState == 1">
          <!-- sourceType 1-桐心保平台单 2-商户录单 -->
          <Button v-if="policyDetail.sourceType == 1" type="primary" @click="generateOrder">生成续保订单</Button>
          <Button v-if="policyDetail.sourceType == 1" type="primary" @click="goOrderList">查看续保订单</Button>
          <Button type="primary" @click="updateStatus">变更续保状态</Button>
        </template>
        <!-- 已续保 -->
        <template v-if="policyDetail.payState == 2">
          <Button v-if="policyDetail.newPolicyNo" type="primary" @click="goOrderList">查看续保订单</Button>
          <Button v-else type="primary" @click="updateStatus">变更续保状态</Button>
        </template>
        <!-- 未续保 -->
        <template v-if="policyDetail.payState == 3">
          <Button type="primary" @click="updateStatus">变更续保状态</Button>
        </template>
      </div>
    </Tabs>
    <div class="stps" v-if="tabIndex == '1'">
      <div class="stps-item" v-for="(item,index) in changeRecordList" :key="index">
        <div class="outer-circle" v-if="index == 0">
          <div class="inner-circle"></div>
          <div class="line" v-if="changeRecordList.length !== index +1"></div>
        </div>
        <div class="noactive-outer-circle" v-else>
          <div class="inner-circle"></div>
          <div class="line" v-if="changeRecordList.length !== index +1"></div>
        </div>
        <div class="step-text">
          <span class="time">{{ item.operateDate }}</span>
          <span class="state" :style="{color:index==0?'#236dff':''}">
            {{ {'1':'即将到期','2':'已续保','3':'未续保'}[item.payState] }}
          </span>
          <span class="desc">{{item.remark || '-'}}</span>
          <span class="action-user">操作人：{{ item.operateUser }}</span>
        </div>
      </div>
      <noData v-if="changeRecordList.length == 0"></noData>
    </div>
    <div v-if="tabIndex == '2'" class="page-form">
      <div class="info">
        <div class="form-title">基本信息</div>
        <div class="form">
          <div class="form-item">
            <span class="label">订单号</span>
            <span class="value">{{ policyDetail.orderNo }}</span>
          </div>
          <div class="form-item">
            <span class="label">保单号</span>
            <span class="value">{{ policyDetail.policyNo }}</span>
          </div>
          <div class="form-item">
            <span class="label">保险期间</span>
            <span class="value">{{ policyDetail.startTime | filterTime('YYYY-MM-DD') }} 至 {{ policyDetail.endTime | filterTime('YYYY-MM-DD') }}</span>
          </div>
          <div class="form-item">
            <span class="label">保险公司</span>
            <span class="value">{{ policyDetail.companyName }}</span>
          </div>
          <div class="form-item">
            <span class="label">业务来源</span>
            <span class="value">{{ { '1': '分销', '2': '直营' }[policyDetail.businessSource] || '-' }}</span>
          </div>
          <div class="form-item">
            <span class="label">出单保费</span>
            <span class="value">{{ policyDetail.fee }}元</span>
          </div>
          <div class="form-item">
            <span class="label">出单业务员</span>
            <span class="value">{{ policyDetail.salesmanName }}</span>
          </div>
          <div class="form-item">
            <span class="label">所属团队</span>
            <span class="value">{{ policyDetail.groupName }}</span>
          </div>
          <div class="form-item">
            <span class="label">所属机构</span>
            <span class="value">{{ policyDetail.orgName }}</span>
          </div>
          <div class="form-item">
            <span class="label">保单状态</span>
            <span class="value">{{ policyDetail.policyStatusDesc }}</span>
          </div>
        </div>
      </div>

      <div class="info">
        <div class="form-title">投保人信息</div>
        <div class="form">
          <div class="form-item">
            <span class="label">姓名</span>
            <span class="value">{{ policyDetail.holderName }}</span>
          </div>
          <div class="form-item">
            <span class="label">证件号码</span>
            <div class="value">
              <span v-if="!policyDetail.eyeShow1">{{ policyDetail.holderCardNo || '-' }}</span>
              <span v-else>{{ policyDetail.holderCardNo1 || '-' }}</span>
              <span v-if="policyDetail.holderCardNo">
                <i class="iconfont iconxianshi eye-icon" v-if="policyDetail.eyeShow1" @click="openEye(policyDetail, 'eyeShow1', 'holderCardNo')"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyDetail, 'eyeShow1', 'holderCardNo')"></i>
              </span>
            </div>
          </div>

          <div class="form-item no-mb">
            <span class="label">详细地址</span>
            <div class="value">
              <span v-if="!policyDetail.eyeShow2">{{ policyDetail.holderAddress || '-' }}</span>
              <span v-else>{{ policyDetail.holderAddress1 || '-' }}</span>
              <span v-if="policyDetail.holderAddress">
                <i class="iconfont iconxianshi eye-icon" v-if="policyDetail.eyeShow2" @click="openEye(policyDetail, 'eyeShow2', 'holderAddress')"></i>
                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(policyDetail, 'eyeShow2', 'holderAddress')"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 变更续保状态 -->
    <update-status ref="updateStatus" @reload="getDetail()" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import formItem from './components/formItem';
import updateStatus from './components/updateStatus';

export default {
  mixins: [common],
  components: {
    updateStatus,
    formItem
  },
  data() {
    return {
      id: '',
      policyDetail: {},
      tabIndex: '1',
      changeRecordList:[],//变更记录
    };
  },

  created() {
    // 获取id
    this.id = this.$route.query.id;
    // 续保信息
    this.getDetail();
    this.queryChangeRecord();
  },

  methods: {
    // 获取变更记录列表
    queryChangeRecord() {
      this.$http({
        url: `/buz/groupPolicyRenewalRecord/queryLogList?id=${this.id}`,
        type: "GET",
      }).then((res) => {
        this.changeRecordList = res.data;
      });
    },
    openEye(item, eyeKey, key) {
      const map = {
        'holderCardNo': 1,
        'holderAddress': 5
      };
      if (!item[eyeKey]) {
        this.descrypt(
          {
            query: item.policyNo,
            operationFunction: 51,
            operationType: map[key]
          },
          item,
          key + '1',
          'order_30_10'
        ).then(() => {
          this.$set(item, eyeKey, true);
        });
      } else {
        this.$set(item, eyeKey, false);
      }
    },
    goBack() {
      this.back('/renewalManage/renewalGroupManage');
    },
    // 续费详情
    getDetail() {
      this.$http({
        url: `/buz/groupPolicyRenewalRecord/read/detail?id=${this.id}`,
        type: 'GET'
      }).then(res => {
        const data = res.data;
        // 即将到期不显示变更记录
        if(data.payState == 1) {
          this.tabIndex = '2';
        }
        this.policyDetail = data;
      });
    },
    // 生成订单
    generateOrder() {
      if (!this.$units.pointAction('renewalManage_04_2')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      const close = this.$notice.loading();
      this.$http({
        url: '/buz/groupPolicyRenewalRecord/generateRenewalOrder',
        type: 'POST',
        data: {
          id: this.policyDetail.id,
          policyNo: this.policyDetail.policyNo
        }
      }).then(res => {
        window.open(res.data);
        this.getDetail();
      }).finally(()=>{
        close();
      });
    },

    // 跳转订单列表
    goOrderList() {
      if (!this.$units.pointAction('renewalManage_04_3')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      if (!this.policyDetail.orderId) {
        this.$notice.error('暂未创建续保订单');
        return;
      }
      sessionStorage.queryOrderNo = this.policyDetail.orderId;
      this.$router.push({
        path: '/orderManage/group/order'
      });
    },
    // 变更续保状态
    updateStatus() {
      if (!this.$units.pointAction('renewalManage_04_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.updateStatus.open(this.policyDetail);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './detail.scss';
/deep/ .ivu-tabs-nav .ivu-tabs-tab-active {
  font-weight: bold;
}
</style>